import React from "react";
import PropTypes from "prop-types";
const HighchartsReact = window.HighchartsReact;

import { MAX_BAR_WIDTH } from "../chartOptions";

const breakdownOptions = (data, currentYear) => {
  const mapCities = () => data.map(d => d.city);
  const mapValues = (value) => (data.map(d => {
    if(!d[value]) {
      d[value] = 0;
    }
    return d[value];
  }));

  return {
    chart: {
      type: "bar",
      height: 500,
      style: {
        fontFamily: "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif"
      }
    },
    credits: {
      enabled: false,
    },
    title: {
      text: `Selected cities ${currentYear} tariff breakdown`,
      style: {
        fontWeight: "bold",
        fontSize: "1.4rem"
      }
    },
    exporting: {
      enabled: false
    },
    legend: {
      itemMarginBottom: 4,
      itemMarginTop: 1,
      itemStyle: {
        fontWeight: "normal"
      },
      layout: "vertical",
      symbolHeight: 14,
      symbolWidth: 14,
      symbolRadius: 0,
      reversed: true,
      events: {
        itemClick: window.highchartsExtras.alternateHighchartsLegendItemClick
      }
    },
    plotOptions: {
      series: {
        stacking: "normal"
      }
    },
    tooltip: {
      animation: true,
      backgroundColor: "transparent",
      borderWidth: 0,
      formatter: function() {
        return `
          <div style="box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.3);">
            <div style="background-color: white; padding: 10px; border-top: 8px solid ${this.color}">
              <b>${this.key}</b></br>
              ${this.series.name}
            </div>
            <div style="background-color: white; padding: 0px 10px 10px 10px; font-size: 14px;">
              <div style="color: ${this.color}; font-weight: bold">
              ${this.series.tooltipOptions.valuePrefix}${this.point.y.toFixed(2)}${this.series.tooltipOptions.valueSuffix}</b>
              </div>
            </div>
            <div style="font-weight: bold; padding: 0 10px 10px 10px">
              Total: ${this.series.tooltipOptions.valuePrefix}${this.point.total}${this.series.tooltipOptions.valueSuffix}
            </div>
          </div>
          `;
      },
      hideDelay: 100,
      shadow: false,
      shape: "square",
      style: { color: "black", padding: 0 },
      useHTML: true,
      valuePrefix: "$",
      valueSuffix: "/m3"
    },
    xAxis: {
      categories: mapCities(),
      lineWidth: 0,
      tickLength: 0
    },
    yAxis: {
      min: 0,
      title: {
        text: "$/m3"
      },
      gridLineWidth: 0,
      tickWidth: 1,
      tickLength: 5,

    },
    series: [
      {
        name: "Wastewater sales tax",
        data: mapValues("total_wastewater_sales_tax_usd"),
        color: "#33bef2",
        maxPointWidth: MAX_BAR_WIDTH,
      },
      {
        name: "Variable wastewater costs",
        data: mapValues("total_variable_wastewater_costs_usd"),
        color: "#3384b7",
        maxPointWidth: MAX_BAR_WIDTH,
      },
      {
        name: "Fixed wastewater costs",
        data: mapValues("total_fixed_wastewater_costs_usd"),
        color: "#c84646",
        maxPointWidth: MAX_BAR_WIDTH,
      },
      {
        name: "Water sales tax",
        data: mapValues("total_water_sales_tax_usd"),
        color: "#f3b050",
        maxPointWidth: MAX_BAR_WIDTH,
      },
      {
        name: "Variable water costs",
        data: mapValues("total_variable_water_costs_usd"),
        color: "#aed36f",
        maxPointWidth: MAX_BAR_WIDTH,
      },
      {
        name: "Fixed water costs",
        data: mapValues("total_fixed_water_costs_usd"),
        color: "#549262",
        maxPointWidth: MAX_BAR_WIDTH,
      },
    ],
  };
};

const TariffBreakdown = ({ highcharts, data, currentYear }) => (
  <HighchartsReact
    highcharts={highcharts}
    constructorType={"chart"}
    options={breakdownOptions(data, currentYear)}
  />
);

export default TariffBreakdown;

TariffBreakdown.propTypes = {
  currentYear: PropTypes.number.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({}).isRequired).isRequired,
  highcharts: PropTypes.shape({
    charts: PropTypes.arrayOf(PropTypes.shape({})),
  }),
};
